import React, { useCallback, memo, useState } from 'react';
import MainImageComponent from './main-image-component';
import ThumbnailImageComponent from './thumbnail-image-component';
import OverlayModal from './overlay-modal';
import FullScreenModal from './full-screen-modal';
import { GridContainer, ThumbnailsGrid, ViewAllOverlay, GalleryIcon } from './styles';
var GalleryGrid = function (_a) {
    var images = _a.images, _b = _a.skipFullScreen, skipFullScreen = _b === void 0 ? false : _b, _c = _a.skipOverlay, skipOverlay = _c === void 0 ? false : _c, imageBorder = _a.imageBorder, imageBorderRadius = _a.imageBorderRadius, onSlideChange = _a.onSlideChange, onGalleryImageClick = _a.onGalleryImageClick, onViewAllClick = _a.onViewAllClick, onFullscreenImageClick = _a.onFullscreenImageClick, footer = _a.footer, header = _a.header, layout = _a.layout, _d = _a.viewAllText, viewAllText = _d === void 0 ? 'View all images' : _d, fontFamily = _a.fontFamily, galleryIconSrc = _a.galleryIconSrc;
    var _e = useState(false), isFullScreen = _e[0], setFullScreen = _e[1];
    var _f = useState(false), isOverlayOpen = _f[0], setOverlay = _f[1];
    var _g = useState(0), selectedImageIndex = _g[0], setSelectedImageIndex = _g[1];
    var openModal = useCallback(function () {
        if (!skipFullScreen) {
            setFullScreen(true);
        }
        else if (!skipOverlay) {
            setOverlay(true);
        }
    }, [skipFullScreen, skipOverlay]);
    var handleImageClick = useCallback(function (index) {
        onGalleryImageClick === null || onGalleryImageClick === void 0 ? void 0 : onGalleryImageClick({
            imageIndex: index,
            layout: layout,
        });
        setSelectedImageIndex(index);
        openModal();
    }, [onGalleryImageClick, layout, openModal]);
    var handleViewAllClick = useCallback(function () {
        onViewAllClick === null || onViewAllClick === void 0 ? void 0 : onViewAllClick();
        handleImageClick(0);
    }, [onViewAllClick, handleImageClick]);
    var goToSlide = useCallback(function (index) {
        setSelectedImageIndex(index);
        onSlideChange === null || onSlideChange === void 0 ? void 0 : onSlideChange(index);
    }, [onSlideChange]);
    if (!images || images.length === 0) {
        return null;
    }
    var mainImage = images[0];
    var thumbnailImages = images.slice(1, 7);
    return (React.createElement(React.Fragment, null,
        React.createElement(GridContainer, null,
            mainImage && (React.createElement(MainImageComponent, { image: mainImage, onClick: function () { return handleImageClick(0); }, imageBorder: imageBorder, imageBorderRadius: imageBorderRadius })),
            React.createElement(ThumbnailsGrid, null, thumbnailImages.map(function (image, index) { return (React.createElement(ThumbnailImageComponent, { key: "thumbnail_" + index, image: image, onClick: function () { return handleImageClick(index + 1); }, imageBorder: imageBorder, imageBorderRadius: imageBorderRadius })); })),
            images.length > 1 && (React.createElement(ViewAllOverlay, { onClick: handleViewAllClick, fontFamily: fontFamily },
                React.createElement(GalleryIcon, { "$iconSrc": galleryIconSrc }),
                viewAllText))),
        isFullScreen && (React.createElement(FullScreenModal, { images: images, isFullScreenOpen: isFullScreen, setFullScreen: setFullScreen, header: header, footer: footer, setOverlay: setOverlay, setSelectedImage: goToSlide, currentIndex: selectedImageIndex, onFullscreenImageClick: onFullscreenImageClick })),
        isOverlayOpen && (React.createElement(OverlayModal, { isOverlayOpen: isOverlayOpen, setOverlay: setOverlay, images: images, initialSlide: selectedImageIndex, setSelectedImage: goToSlide }))));
};
export default memo(GalleryGrid);
